export const authLayoutRoutes = [
  "/login",
  "/two-factor-auth",
  "/two-factor-acknowledgement",
  "/link-account-login",
  "/forgot-password",
  "/modify-password",
  "/confirmlogin",
];

export function isAuthLayoutRoute(pathname: string): boolean {
  const path = pathname.toLowerCase();
  return authLayoutRoutes.some(
    (route) => path === route || path.startsWith(route + "/")
  );
}
